import React, { useEffect, useState, createElement } from 'react';
import { Anchor } from 'antd';
import styled from 'styled-components';
import { isDef, isFunc } from '../../utils';
const { Link } = Anchor;
const TabScrollStyle = styled.div `
  .anchor-wrapper {
    position: sticky;
    z-index: 5;
    box-shadow: 0px 6px 10px -7px rgba(0, 0, 0, 0.11);
    background-color: #fff;
    .ant-anchor-wrapper {
      .ant-anchor {
        display: flex;
        flex-direction: row;
        height: 60px;
        padding-left: 0;
        .ant-anchor-ink {
          display: none;
        }
        .ant-anchor-link {
          padding: 0 24px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .ant-anchor-link-title {
            font-size: 14px;
            color: #1a1a1a;
          }
        }
        .ant-anchor-link-active {
          &:after {
            content: '';
            width: 24px;
            height: 4px;
            margin-top: 6px;
            background-color: #ff571a;
            border-radius: 2px;
            position: absolute;
            bottom: 8px;
          }
        }
      }
    }
  }
  .child-wrapper {
    position: relative;
    > * {
      padding-bottom: 24px;
    }
  }
`;
function TabScroll({ onTabClick, getContainer = () => document.getElementsByClassName('next-shell-sub-main')[0] || window, contentMargin = 24, stickyTop = () => 103, relativeTargetOffset = 20, children, ...restProps }) {
    const top = stickyTop();
    const { linkList, childNodes } = useComputeChild(children, contentMargin);
    const onAnchorClick = (e, { title, href }) => {
        e.preventDefault();
        isFunc(onTabClick) &&
            onTabClick({
                title,
                key: href.slice(1),
            });
    };
    return (createElement(TabScrollStyle, { ...restProps },
        createElement("div", { className: "anchor-wrapper", style: {
                top,
            } },
            createElement(Anchor, { affix: false, offsetTop: 0, onClick: onAnchorClick, getContainer: getContainer, targetOffset: top + 60 + relativeTargetOffset }, linkList.map(({ key, tab }) => (createElement(Link, { href: `#${key}`, title: tab, key: key }))))),
        createElement("div", { className: "child-wrapper" }, childNodes)));
}
function getChildren(children, contentMargin) {
    const linkArr = [];
    const childArr = [];
    const childrenArr = React.Children.toArray(children);
    React.Children.map(childrenArr, (child) => {
        if (isDef(child)) {
            const key = child.key.slice(2) || 'key';
            const { children, tab, style, ...rest } = child.props;
            if (!key) {
                console.error('There must be `key` property on children of TabsScroll.');
            }
            if (!tab) {
                console.error('There must be `tab` property on children of TabsScroll.');
            }
            let childTemp = child;
            if (child.type.type === TabScroll.TabPane.type && key) {
                childTemp = (createElement("div", { id: key, key: key, style: {
                        margin: `${contentMargin}px`,
                        marginBottom: 0,
                        ...style,
                    }, ...rest }, children));
                linkArr.push({ tab, key });
            }
            childArr.push(childTemp);
        }
    });
    return { linkList: linkArr, childNodes: childArr };
}
function useComputeChild(children, contentMargin) {
    const [linkList, setLinkList] = useState([]);
    const [childNodes, setChildNodes] = useState([]);
    useEffect(() => {
        const { linkList, childNodes } = getChildren(children, contentMargin);
        setLinkList(linkList);
        setChildNodes(childNodes);
    }, [children, contentMargin]);
    return { linkList, childNodes };
}
function TabPane(props) {
    const { children, ...otherProps } = props;
    return createElement("div", { ...otherProps }, children);
}
TabPane.type = 'TabPane__type777';
TabScroll.TabPane = TabPane;
TabScroll.displayName = 'TabScroll';
export default TabScroll;
